import React from "react";
import moment from "moment";
import { Col, Row, Button, Input } from "reactstrap";
import ToolkitProvider, {
  CSVExport
} from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import { Link } from "react-router-dom";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { useTranslation } from "react-i18next";


const TokensTable = ({ tableData, searchQuery, defaultSorted }) => {
  const { ExportCSVButton } = CSVExport;
  const { t } = useTranslation();

  const tokensFormatter = (cell, row) => <b>{cell}</b>;

  const dateFormatter = (cell, row) => {
    return (
      moment(cell).format('YYYY-MM-DD')
    );
  };
  
  const receiptFormatter = cell =>
    cell ?
    (
      <a href={cell} target="blank">
      <Button className="btn-status" color="primary">
        <b>{t("tokens.view.table.button.view")}</b>
      </Button>
      </a>
    ) : <b>{t("tokens.view.table.label.not_available")}</b>;

  const kindFormatter = cell => {
    return cell === "credit" ? 
    <Button className="btn-status" color="success">
      <b className="mdi mdi-plus pr-2">{t("tokens.view.table.label.credit")}</b>
    </Button> : 
    <Button className="btn-status" color="danger">
      <b className="mdi mdi-minus pr-2">{t("tokens.view.table.label.debit")}</b>
    </Button>;
  };

  const columns = [
    {
      dataField: "quantity",
      text: t("tokens.view.table.column.quantity"),
      sort: true,
      formatter: tokensFormatter,
    },
    {
      dataField: "description",
      text: t("tokens.view.table.column.description"),
      sort: false,
    },
    {
      dataField: "kind",
      text: t("tokens.view.table.column.type"),
      sort: true,
      formatter: kindFormatter,
    },
    {
      dataField: "balance",
      text: t("tokens.view.table.column.balance"),
      sort: true,
      formatter: tokensFormatter,
    },
    {
      dataField: "created",
      text: t("tokens.view.table.column.date"),
      sort: true,
      formatter: dateFormatter,
      csvFormatter: dateFormatter,
    },
    {
      dataField: "stripe_receipt_url",
      text: t("tokens.view.table.column.receipt"),
      sort: false,
      formatter: receiptFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "120px" };
      }
    },
  ];

  const handleTableChange = (type, { sortField, sortOrder, data }) => {
    const ascDesc = sortOrder === "desc" ? "-" : "";
    if (sortField === "quantity" || sortField === "kind" || sortField === "balance" || sortField === "created") {
      searchQuery.setOrdering({order: ascDesc, name: sortField, sort: sortField});
    }
  }

  return (
    <ToolkitProvider
      keyField="id"
      data={tableData}
      columns={columns}
      search={{
        searchFormatted: true
      }}
      exportCSV={ {
        fileName: 'tokens.csv',
      } }
    >
      {props => (
        <div>
          <Row>
            <Col>
              <div className="customSearch">
                <Input placeholder={t("tokens.view.table.placeholder.search")} value={searchQuery.query} style={{marginBottom: 10}} onChange={e => searchQuery.setQuery(e.target.value)}/>
              </div>
            </Col>
            <Col>
              <div className="flexEndContainer">
                <ExportCSVButton
                  className="btn btn-outline-info"
                  {...props.csvProps}
                >
                  {t("tokens.view.table.button.export_csv")}
                </ExportCSVButton>
                <Link to="/tokens/order" className="ml-2 btn btn-outline-success">{t("tokens.view.table.button.order_tokens")}</Link>
              </div>
            </Col>
          </Row>
          <BootstrapTable
            {...props.baseProps}
            bordered={ false }
            remote={ { sort: true } }
            defaultSorted={defaultSorted}
            onTableChange={handleTableChange}
          />
        </div>
      )}
    </ToolkitProvider>
  );
};

export default TokensTable;